var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "my_account" } }, [
    _c("div", { staticClass: "bg-cl-transparent py35 pl20" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("breadcrumbs", {
            attrs: {
              "with-homepage": true,
              routes: [],
              "active-route": _vm.$t("My Account")
            }
          }),
          _vm._v(" "),
          _c("h1", [
            _vm._v("\n        " + _vm._s(_vm.$t("My Account")) + "\n      ")
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container pt45 pb70" }, [
      _c("div", { staticClass: "row px20 pt0" }, [
        _c("div", { staticClass: "col-md-3 hidden-xs hidden-sm block" }, [
          _c("nav", { staticClass: "static-menu sans-serif h4 mb35" }, [
            _c(
              "ul",
              { staticClass: "m0 p0" },
              _vm._l(_vm.navigation, function(page, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "mb20 pb20 brdr-bottom-1",
                    on: {
                      click: function($event) {
                        return _vm.notify(page.title)
                      }
                    }
                  },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: _vm.localizedRoute(page.link) } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(page.title) +
                            "\n              "
                        )
                      ]
                    )
                  ],
                  1
                )
              }),
              0
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-9" },
          [
            _c(
              "no-ssr",
              [
                _c(this.$props.activeBlock, {
                  tag: "component",
                  attrs: { categoryProps: _vm.getCurrentCategory.catalog }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }